import { useEffect, useState } from "react";
import { ProjectContainer } from "../styles/projectTab";
import CamperImg from "../assets/camper.webp";
import CrmImg from "../assets/crm.webp";
import Xalqlar from "../assets/xalqlar.webp";
import XalqlarAdmin from "../assets/xalqlar-admin.png";
import CamperAdmin from "../assets/camper-admin.webp";
import KoreaAvto from "../assets/koreavto.png";
import HalalCompass from "../assets/halal.png";
import { ProjectCard } from "./project-card";

const All = () => {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpacity(1);
    }, 200);

    return () => clearTimeout(timer);
  }, []);
  return (
    <ProjectContainer style={{ opacity, transition: "opacity 0.5s" }}>
      <ProjectCard
        link="https://play.google.com/store/apps/details?id=com.urckoreaauto.app&hl=en"
        image={KoreaAvto}
        title="Korea Avto"
        subtitle="Mobile application"
      />
      <ProjectCard
        link="https://play.google.com/store/apps/details?id=com.xalqlardostligi.app"
        image={Xalqlar}
        title="Xalqlar do'stligi (Halal food)"
        subtitle="Mobile applicationss"
      />
      <ProjectCard
        link="https://play.google.com/store/apps/details?id=com.urconhalalcompass.app&hl=enn"
        image={HalalCompass}
        title="Halal Compass"
        subtitle="Mobile application"
      />
      <ProjectCard
        link="https://xalqlar-dostligi.uz/auth/login"
        image={XalqlarAdmin}
        title="Xalqlar (admin-dashboard)"
        subtitle="Web application"
      />
      <ProjectCard
        link="https://tripli.inomjonov.site"
        image={CamperImg}
        title="TRIPLi"
        subtitle="Web application"
      />
      <ProjectCard
        link="https://lms.inomjonov.site"
        image={CrmImg}
        title="EduManSim (Learning Management System)"
        subtitle="Web applicationss"
      />

      <ProjectCard
        link="https://admin-dashboard.camper.inomjonov.site"
        image={CamperAdmin}
        title="TRIPLi (admin-dashboard)"
        subtitle="Web applicationss"
      />
    </ProjectContainer>
  );
};

export default All;
